var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSocket = function SvgSocket(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 413,
    height: 413,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 413 413",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 22.926,
    strokeWidth: 8.33,
    d: "M42.03 38.38h332.2v337.18H42.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 22.926,
    strokeWidth: 8.33,
    d: "M208.54 74.23c74.07 0 134.12 60.05 134.12 134.12s-60.05 134.11-134.12 134.11S74.42 282.42 74.42 208.35 134.47 74.23 208.54 74.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M129.81 211.33c0 10.42 8.34 18.87 18.62 18.87s18.61-8.45 18.61-18.87c0-10.43-8.33-18.88-18.61-18.88s-18.62 8.45-18.62 18.88m120.13 0c0 10.42 8.33 18.87 18.61 18.87s18.61-8.45 18.61-18.87c0-10.43-8.33-18.88-18.61-18.88s-18.61 8.45-18.61 18.88m-42.03-15.56c8.83 0 15.98 7.15 15.98 15.98 0 8.82-7.15 15.97-15.98 15.97-8.82 0-15.97-7.15-15.97-15.97 0-8.83 7.15-15.98 15.97-15.98M88.94 194.7h17.62c.56 0 1.01-.44 1.01-1v-53.29c19.28-30.17 51.38-51.13 88.48-54.96l.01 29.91c.16 3.94 4.19 8.97 11.37 9.34 8.93-.11 11.54-6.12 11.57-8.97V85.3c37.37 3.33 69.83 24.06 89.46 54.12v54.28c0 .55.43.99.98 1h18.38c.58 7.89.71 15.38 0 23.26h-18.36c-.54 0-.99.44-1 .99v54.62c-19.64 30.08-52.09 50.77-89.47 54.1l-.02-30.53c-.03-2.85-2.64-8.86-11.57-8.97-7.18.37-11.21 5.4-11.37 9.34l-.01 30c-37.09-3.83-69.19-24.8-88.46-54.96l.01-53.58v-.02c-.02-.55-.46-.99-1.01-.99H88.93c-.84-7.85-.92-15.61.01-23.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M219.11 209.31h-5.56c-1.46 0-2.64-1.19-2.64-2.66v-5.79c0-1.47-1.17-2.67-2.62-2.67h-.31c-1.45 0-2.62 1.2-2.62 2.67v5.79c0 1.47-1.19 2.66-2.64 2.66h-5.56c-1.45 0-2.63 1.2-2.63 2.68 0 1.47 1.18 2.66 2.63 2.66h5.56c1.45 0 2.64 1.19 2.64 2.67v5.79c0 1.47 1.17 2.67 2.62 2.67h.31c1.45 0 2.62-1.2 2.62-2.67v-5.79c0-1.48 1.18-2.67 2.64-2.67h5.56c1.45 0 2.62-1.19 2.62-2.66 0-1.48-1.17-2.68-2.62-2.68"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSocket);
export default ForwardRef;